export default __webpack_public_path__ + "static/media/home-bg-four.14e606bf.svg";